import React, { useEffect, useRef, useState } from "react";
import Topbar from "../Topbar/Topbar";
import "./Attendance.css";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { useDownloadExcel } from "react-export-table-to-excel";

export default function Attendance() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const staffId = useSelector((state) => state.id);
  const role = useSelector((state) => state.roleName);
  console.log(role, "role");

  console.log(staffId, "userid");
  const [staffName, setStaffName] = useState([]);
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const permission = useSelector((state) => state.permissions);
  // const options = ["Saravanan", "Ravikumar", "Sathishkumar", "Venkatesh"];
  const [selectedValues, setSelectedValues] = useState([]);
  const [dateHeaders, setDateHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 7); // Format: "2025-07"
  });
  // Function to handle month selection and generate date headers
  const generateHeaders = (year, month) => {
    const numDays = new Date(year, month, 0).getDate();
    const headers = [];

    for (let day = 1; day <= numDays; day++) {
      const dateObj = new Date(year, month - 1, day);
      const dayName = weekdays[dateObj.getDay()];
      headers.push({ label: `${dayName} ${day}`, day });
    }

    setDateHeaders(headers);
  };
  const isSuperAdmin = role && role.toLowerCase().replace(/\s+/g, '') === 'superadmin';

  //handleGenerate function to fetch attendance data
  const handleGenerate = async () => {
    const targetStaffId = isSuperAdmin ? selectedValues[0] : staffId;

    if (!selectedMonth || !targetStaffId) {
      alert("Please select all fields");
      return;
    }

    const [year, month] = selectedMonth.split("-").map(Number);
    console.log("Selected Year:", year, "Month:", month);

    // ⏱️ Generate headers
    const numDays = new Date(year, month, 0).getDate();
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const headers = [];

    for (let day = 1; day <= numDays; day++) {
      const dateObj = new Date(year, month - 1, day);
      const dayName = weekdays[dateObj.getDay()];
      headers.push({ label: `${dayName} ${day}`, day });
    }

    setDateHeaders(headers);

    try {
      const response = await axios.get(`${apiUrl}/attendance/monthfilter`, {
        params: { staffId: targetStaffId, year, month },
      });
      console.log("API Response:", response.data);

      const attendanceArray = response.data?.data || [];
      if (!Array.isArray(attendanceArray)) {
        console.error("API returned invalid data array");
        return;
      }

      const formattedData = {};
      attendanceArray.forEach((rec) => {
        const day = new Date(rec.date).getDate();
        formattedData[day] = rec;
      });

      //  Set table data
      setTableData(formattedData);

      //  Set attendance stats
      const stats = getAttendanceStats(formattedData, headers, selectedMonth);
      setAttendanceStats(stats);
    } catch (error) {
      console.error("Fetch failed:", error);
      setTableData({});
      setAttendanceStats({
        presentCount: 0,
        absentCount: 0,
        formattedBreakTime: "0H 0M",
        totalWorkTimeHM: "0H 0M",
        totalExtraTimeHM: "0H 0M",
        totalIdleTimeHM: "0H 0M",
        avgWorkTimeHM: "0H 0M",
        avgExtraTimeHM: "0H 0M",
        avgIdleTimeHM: "0H 0M",
      });
    }
  };
  //without lick the generate button, the table should be generated

  //staff name selection handler
  const handleChange = (event) => {
    const value = event.target.value;
    if (value.includes("all")) {
      setSelectedValues(
        selectedValues.length === staffName.length ? [] : staffName
      );
    } else {
      setSelectedValues(value);
    }
  };
  // Calculate attendance statistics
  const formatToHM = (mins) => {
    const h = Math.floor(mins / 60);
    const m = Math.round(mins % 60);
    return `${h}H ${m}M`;
  };
  const [attendanceStats, setAttendanceStats] = useState({
    presentCount: 0,
    absentCount: 0,
    formattedBreakTime: "0H 0M",
    totalWorkTimeHM: "0H 0M",
    totalExtraTimeHM: "0H 0M",
    totalIdleTimeHM: "0H 0M",
    avgWorkTimeHM: "0H 0M",
    avgExtraTimeHM: "0H 0M",
    avgIdleTimeHM: "0H 0M",
  });
  const getAttendanceStats = (tableData, dateHeaders, selectedMonth) => {
    const [year, month] = selectedMonth.split("-").map(Number);
    const today = new Date();

    const presentCount = Object.keys(tableData).length;

    const absentCount = dateHeaders.filter(({ day }) => {
      const date = new Date(year, month - 1, day);
      return date <= today && !tableData[day];
    }).length;

    const sumByKey = (key) =>
      Object.values(tableData).reduce((sum, item) => sum + (item[key] || 0), 0);

    const totalWorkTime = sumByKey("totalTimeWithoutBreak");
    const totalExtraTime = sumByKey("extraTime");
    const totalIdleTime = sumByKey("idleTime");
    const totalBreakTime = sumByKey("breakTime");

    const avg = (val) => (presentCount > 0 ? val / presentCount : 0);

    return {
      presentCount,
      absentCount,
      formattedBreakTime: formatToHM(totalBreakTime),
      totalWorkTimeHM: formatToHM(totalWorkTime),
      totalExtraTimeHM: formatToHM(totalExtraTime),
      totalIdleTimeHM: formatToHM(totalIdleTime),
      avgWorkTimeHM: formatToHM(avg(totalWorkTime)),
      avgExtraTimeHM: formatToHM(avg(totalExtraTime)),
      avgIdleTimeHM: formatToHM(avg(totalIdleTime)),
    };
  };
  //useeffect to fetch the staffname

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await axios.get(`${apiUrl}/get-staff-names`);
        const staffList = res.data.message
          .filter((s) => s.staffName && s._id)
          .map((s) => ({
            name: s.staffName,
            id: s._id,
          }));

        setStaffName(staffList); // ⬅️ stored in state
      } catch (err) {
        console.error("Error fetching staff names:", err);
      }
    };

    fetchStaff();
  }, []);

  useEffect(() => {
    const [year, month] = selectedMonth.split("-").map(Number);
    generateHeaders(year, month);

    if (!isSuperAdmin) {
      handleGenerate();
    }
  }, []);
  useEffect(() => {
    if (isSuperAdmin && staffName.length > 0) {
      setSelectedValues([staffName[0].id]);
    }
  }, [staffName]);
  //code for exporting the attendance data
   const tableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
      currentTableRef: tableRef.current,
      filename: "Attendance_data",
      sheet: "Attendance",
    });
  const [shouldExport, setShouldExport] = useState(false);
  const handleExportConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to export the Attendance details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, export it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
        setShouldExport(true); // Allow the export to proceed
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The export operation was cancelled.", "error");
        setShouldExport(false);
      }
    });
  };
  return (
    <div>
      <Topbar />
      <div className="container">
        <h3 className="">Attendance</h3>
        {/* Row 1 */}
        <div className="row">
         
          {/* {role === "Super Admin" && staffName.length > 0 && (
            <div className="col-md-3 col-sm-12">
              <FormControl sx={{ width: "200px" }} >
                <InputLabel
               
                  id="checkbox-select-label"
                  shrink={selectedValues.length > 0}
                ></InputLabel>
                <Select
                 className="attendance-date"
                  labelId="checkbox-select-label"
                  id="checkbox-select"
                  multiple
                  value={selectedValues}
                  onChange={handleChange}
                  displayEmpty
                  sx={{
                    height: "47px",
                    fontSize: "14px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                  renderValue={(selected) =>
                    selected.length === 0 ? "Select Staff" : selected.join(", ")
                  }
                >
                  <MenuItem value="all">
                    <ListItemText primary="All" />
                    <Checkbox
                      checked={selectedValues.length === staffName.length}
                    />
                  </MenuItem>
                  {staffName.map((staff) => (
                    <MenuItem key={staff.id} value={staff.id}>
                      <ListItemText primary={staff.name} />
                      <Checkbox checked={selectedValues.includes(staff.staffName)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )} */}
          {isSuperAdmin && staffName.length > 0 && (
  <div className="col-md-3 col-sm-12">
    <FormControl sx={{ width: "200px" }}>
      <Select
        className="attendance-date"
        value={selectedValues[0] || ""}
        onChange={(e) => setSelectedValues([e.target.value])}
        displayEmpty
        sx={{
          height: "47px",
          fontSize: "14px",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <MenuItem value="">
          <em>Select Staff</em>
        </MenuItem>
        {staffName.map((staff) => (
          <MenuItem key={staff.id} value={staff.id}>
            {staff.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>
)}


          <div className="col-md-2 col-sm-4">
            <div>
              <input
              className="form-control attendance-date"
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-12" ></div>

          <div className="col-md-3 col-sm-12 text-center">
            <div className="staff-generate">
              <button className="staff-generate-btn" onClick={handleGenerate}>
                Generate
              </button>
            </div>
          </div>
        </div>
        {/* Row 2 */}
        <div className="row card-background mt-4">
          <div className="row">
            <div className="col-md-6 col-sm-12 mt-4">
              {" "}
              <h4> Relie Network Provider </h4>
            </div>
            <div className="col-md-6 col-sm-12 mt-3 ">
              <div className="attendance-exp-btn">
                {permission?.Attendance?.["Attendance Module"]?.Read && (
                  <button className="black-btn  text-center">
                    <b onClick={handleExportConfirmation }>Export</b>
                  </button>
                )}
              </div>
            </div>
          </div>
          {permission?.Attendance?.["Attendance Statistics"]?.Read && (
            <div className="row ">
              <div className="col mt-4 m-1 ">
                <div className="row card-border">
                  <div className="row green-card align-box ">
                    <p className="text-center mt-3">Present</p>
                  </div>
                  <div className="row">
                    <h5 className="text-center">
                      {attendanceStats.presentCount}
                    </h5>
                  </div>
                </div>
                {/* <div className="row">
                  <p className="text-center">
                    {" "}
                    <b>Avg/M - 29D</b>
                  </p>
                </div> */}
              </div>

              <div className="col mt-4 m-1  ">
                <div className="row card-border">
                  {" "}
                  <div className="row red-card align-box">
                    {" "}
                    <p className="text-center mt-3">Off</p>
                  </div>
                  <div className="row">
                    {" "}
                    <h5 className="text-center">
                      {attendanceStats.absentCount}
                    </h5>
                  </div>
                </div>
                {/* <div className="row">
                  <p className="text-center">
                    <b> Avg/M - 29D </b>
                  </p>
                </div> */}
              </div>
              <div className="col mt-4 m-1 ">
                <div className="row card-border">
                  <div className="row purple-card align-box">
                    {" "}
                    <p className="text-center mt-3">Work Time</p>
                  </div>
                  <div className="row">
                    {" "}
                    <h5 className="text-center">
                      {attendanceStats.totalWorkTimeHM}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <p className="text-center">
                    <b> Avg/D - {attendanceStats.avgWorkTimeHM}M </b>
                  </p>
                </div>
              </div>
              <div className="col mt-4 ">
                <div className="row card-border">
                  {" "}
                  <div className="row brown-card align-box">
                    {" "}
                    <p className="text-center mt-3">Idle Time</p>
                  </div>
                  <div className="row">
                    {" "}
                    <h5 className="text-center">
                      {attendanceStats.totalIdleTimeHM}
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <p className="text-center">
                    <b> Avg/D - {attendanceStats.avgIdleTimeHM} </b>
                  </p>
                </div>
              </div>
              <div className="col mt-4 m-1  ">
                <div className="row card-border">
                  {" "}
                  <div className="row yellow-card align-box">
                    {" "}
                    <p className="text-center mt-3">Extra Time</p>
                  </div>
                  <div className="row">
                    {" "}
                    <h5 className="text-center">
                      {attendanceStats.totalExtraTimeHM}
                    </h5>
                  </div>
                </div>

                <div className="row">
                  <p className="text-center">
                    <b>Avg/D - {attendanceStats.avgExtraTimeHM}</b>
                  </p>
                </div>
              </div>
              <div className="col mt-4 m-1  ">
                <div className="row card-border">
                  <div className="row blue-card align-box">
                    {" "}
                    <p className="text-center mt-3">Break Time</p>
                  </div>
                  <div className="row">
                    {" "}
                    <h5 className="text-center">
                      {attendanceStats.formattedBreakTime}
                    </h5>
                  </div>
                </div>
                {/* <div className="row">
                  <p className="text-center">
                    <b>Avg/M - 29D</b>
                  </p>
                </div> */}
              </div>
            </div>
          )}
        </div>
        {/* Row 3 */}
        <div className="row mt-5">
          <div className="attendance-table-container">
            {dateHeaders.length > 0 && (
              <div className="attendance-table-container">
                <table className="attendance-table table-bordered" ref={tableRef}>
                  <thead>
                    <tr>
                      <th className="row-label blue-txt attendance-td ">
                        Date
                      </th>
                      {dateHeaders.map((header, idx) => (
                        <th className="table-th attendance-th" key={idx}>
                          {header.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {/* ✅ Status Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Status
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const today = new Date();
                        const [year, month] = selectedMonth
                          .split("-")
                          .map(Number);
                        const currentDate = new Date(year, month - 1, day);
                        const isFuture = currentDate > today;

                        const data = tableData[day];

                        let display = "-";
                        if (data) {
                          display = "P";
                        } else if (!isFuture) {
                          display = "A";
                        }

                        return <td key={idx}>{display}</td>;
                      })}
                    </tr>

                    {/* ✅ In Time Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        In Time
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const raw = tableData[day]?.inTime?.dateTime;
                        const inTime = raw
                          ? new Date(raw).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "-";
                        return <td key={idx}>{inTime}</td>;
                      })}
                    </tr>

                    {/* ✅ Break Duration Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Break Duration
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const breakMin = tableData[day]?.breakTime;
                        return (
                          <td key={idx}>{breakMin ? `${breakMin} M` : "-"}</td>
                        );
                      })}
                    </tr>

                    {/* ✅ Ideal Time Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Ideal Time
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const idle = tableData[day]?.idleTime;
                        return <td key={idx}>{idle ? `${idle} M` : "-"}</td>;
                      })}
                    </tr>

                    {/* ✅ Work Time Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Work Time
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const work = tableData[day]?.totalTimeWithoutBreak;
                        return <td key={idx}>{work ? `${work} M` : "-"}</td>;
                      })}
                    </tr>

                    {/* ✅ Extra Time Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Extra Time
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const extra = tableData[day]?.extraTime;
                        return <td key={idx}>{extra ? `${extra} M` : "-"}</td>;
                      })}
                    </tr>

                    {/* ✅ Out Time Row */}
                    <tr>
                      <td className="row-label blue-txt attendance-td ">
                        Out Time
                      </td>
                      {dateHeaders.map(({ day }, idx) => {
                        const raw = tableData[day]?.outTime?.dateTime;
                        const outTime = raw
                          ? new Date(raw).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : "-";
                        return <td key={idx}>{outTime}</td>;
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
